import React, { useEffect } from "react";
import { Card, Dropdown, DropdownButton } from "react-bootstrap";
import { ConfCampoLivre } from "./ConfCampoLivre";
import ConfPersonalizacoeselecao from "./ConfPersonalizacoeselecao";
import { ConfCampoBoolean } from "./ConfBoolean";
import { ConfCampoData } from "./ConfData";
import { ConfCampoIntervaloData } from "./ConfCampoIntervaloData";

export enum ETipoCampo {
  texto = 1,
  texto_multilinha = 2,
  selecao = 3,
  data = 4,
  booleano = 5,
  intervalo_data = 6,
  selecao_multipla = 7,
}

export interface IPersonalizacao {
  id?: number;
  nome: string;
  tipocampo_id: number;
  obrigatorio?: boolean;
  programa_id: boolean;
  opcoes?: any[];
  configuracao?: any;
}

interface IPersonalizacoesProps {
  personalizacoes: IPersonalizacao[];
  setPersonalizacoes: Function;
}

export default function Personalizacoes({
  personalizacoes,
  setPersonalizacoes,
}: IPersonalizacoesProps) {
  function criarCampo(tipocampo_id: ETipoCampo) {
    const novoCampo: IPersonalizacao = {
      nome: "",
      tipocampo_id,
      obrigatorio: false,
      programa_id: false,
      opcoes: [],
      configuracao: {},
    };

    if (tipocampo_id === ETipoCampo.texto_multilinha) {
      novoCampo.configuracao = {
        multilinha: true,
      };
    }

    if (tipocampo_id === ETipoCampo.booleano) {
      novoCampo.configuracao = {
        valorPadrao: false,
      };
    }

    setPersonalizacoes((old) => [...old, novoCampo]);
  }

  function atualizarCampo(index: number, alteracoes: Partial<IPersonalizacao>) {
    setPersonalizacoes((old) =>
      old.map((campo, i) =>
        i === index
          ? {
              ...campo,
              ...alteracoes,
            }
          : campo,
      ),
    );
  }

  function atualizarConfiguracao(index: number, alteracoes: any) {
    setPersonalizacoes((old) =>
      old.map((campo, i) =>
        i === index
          ? {
              ...campo,
              configuracao: {
                ...campo.configuracao,
                ...alteracoes,
              },
            }
          : campo,
      ),
    );
  }

  function removerCampo(index: number) {
    setPersonalizacoes((old) => old.filter((_, i) => i !== index));
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Personalização</Card.Title>
      </Card.Header>

      <Card.Body>
        <div
          className="mb-3"
          style={{
            display: "flex",
            justifyContent: "right",
          }}
        >
          <DropdownButton
            title={
              <>
                <i className="mdi mdi-plus-circle me-1" />
                Criar Personalização
              </>
            }
          >
            <Dropdown.Item onClick={() => criarCampo(ETipoCampo.texto)}>
              Campo Livre
            </Dropdown.Item>

            <Dropdown.Item onClick={() => criarCampo(ETipoCampo.selecao)}>
              Seleção
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() => criarCampo(ETipoCampo.selecao_multipla)}
            >
              Seleção Múltipla
            </Dropdown.Item>

            <Dropdown.Item onClick={() => criarCampo(ETipoCampo.booleano)}>
              Sim ou Não
            </Dropdown.Item>

            <Dropdown.Item onClick={() => criarCampo(ETipoCampo.data)}>
              Data
            </Dropdown.Item>

            <Dropdown.Item
              onClick={() => criarCampo(ETipoCampo.intervalo_data)}
            >
              Intervalo de Datas
            </Dropdown.Item>
          </DropdownButton>
        </div>

        <div
          style={{
            marginTop: "10px",
          }}
        >
          <Card>
            <Card.Body>
              <i className="mdi mdi-lock-outline me-1" />
              Dicas - Seleção múltipla
            </Card.Body>
          </Card>
        </div>

        {personalizacoes.map((p, index) => (
          <div key={p.id ?? index} className="mb-3">
            {(p.tipocampo_id === ETipoCampo.texto ||
              p.tipocampo_id === ETipoCampo.texto_multilinha) && (
              <ConfCampoLivre
                titulo={p.nome}
                obrigatorio={p.obrigatorio ?? false}
                multilinha={p.tipocampo_id === ETipoCampo.texto_multilinha}
                onDelete={() => removerCampo(index)}
                onTitleChange={(titulo) =>
                  atualizarCampo(index, {
                    nome: titulo,
                  })
                }
                onSwitchChange={(multilinha) =>
                  atualizarCampo(index, {
                    tipocampo_id: multilinha
                      ? ETipoCampo.texto_multilinha
                      : ETipoCampo.texto,
                  })
                }
                onRequiredChange={(obrigatorio) =>
                  atualizarCampo(index, {
                    obrigatorio,
                  })
                }
              />
            )}

            {(p.tipocampo_id === ETipoCampo.selecao ||
              p.tipocampo_id === ETipoCampo.selecao_multipla) && (
              <ConfPersonalizacoeselecao
                titulo={p.nome}
                obrigatorio={p.obrigatorio ?? false}
                multipla={p.tipocampo_id === ETipoCampo.selecao_multipla}
                opcoes={p.opcoes ?? []}
                novaOpcao={p.configuracao?.novaOpcao ?? ""}
                onDelete={() => removerCampo(index)}
                onTitleChange={(titulo) =>
                  atualizarCampo(index, {
                    nome: titulo,
                  })
                }
                onOptionsChange={(opcoes) =>
                  atualizarCampo(index, {
                    opcoes,
                  })
                }
                onNovaOpcaoChange={(novaOpcao) =>
                  atualizarConfiguracao(index, {
                    novaOpcao,
                  })
                }
                onRequiredChange={(obrigatorio) =>
                  atualizarCampo(index, {
                    obrigatorio,
                  })
                }
              />
            )}

            {p.tipocampo_id === ETipoCampo.booleano && (
              <ConfCampoBoolean
                titulo={p.nome}
                obrigatorio={p.obrigatorio ?? false}
                valorPadrao={p.configuracao?.valorPadrao ?? false}
                onDelete={() => removerCampo(index)}
                onTitleChange={(titulo) =>
                  atualizarCampo(index, {
                    nome: titulo,
                  })
                }
                onValueChange={(valor) =>
                  atualizarConfiguracao(index, {
                    valorPadrao: valor,
                  })
                }
                onRequiredChange={(obrigatorio) =>
                  atualizarCampo(index, {
                    obrigatorio,
                  })
                }
              />
            )}

            {p.tipocampo_id === ETipoCampo.data && (
              <ConfCampoData
                titulo={p.nome}
                obrigatorio={p.obrigatorio ?? false}
                onDelete={() => removerCampo(index)}
                onTitleChange={(titulo) =>
                  atualizarCampo(index, {
                    nome: titulo,
                  })
                }
                onRequiredChange={(obrigatorio) =>
                  atualizarCampo(index, {
                    obrigatorio,
                  })
                }
              />
            )}

            {p.tipocampo_id === ETipoCampo.intervalo_data && (
              <ConfCampoIntervaloData
                titulo={p.nome}
                obrigatorio={p.obrigatorio ?? false}
                onDelete={() => removerCampo(index)}
                onTitleChange={(titulo) =>
                  atualizarCampo(index, {
                    nome: titulo,
                  })
                }
                onRequiredChange={(obrigatorio) =>
                  atualizarCampo(index, {
                    obrigatorio,
                  })
                }
              />
            )}
          </div>
        ))}
      </Card.Body>
    </Card>
  );
}
